import { IOrganization, OrgUtils } from "@smartrr/shared/entities/Organization";
import { IPurchaseState, PurchaseStateAndDelivery } from "@smartrr/shared/entities/PurchaseState";
import { ScheduledDeliveryGroupWithPurchSt } from "@smartrr/shared/entities/PurchaseState/scheduleUtils";
import { RRuleManager } from "@smartrr/shared/entities/Schedule/RRuleManager";
import { isCPSLineItemApartOfBundle } from "@smartrr/shared/utils/bundles";
import { getNextActualDeliveryForCpsGroup } from "@smartrr/shared/utils/getScheduledDeliveries";
import { typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";
import { byAddonStatus, byCreatedDatesLineItems } from "@smartrr/shared/utils/sortBy";

import { useBasicSubscriptionInfo } from "../../../Modals/ManageSubscriptionsModal/hooks/useBasicSubscriptionInfo";

export function sortAndFilterLineItemsForDisplay(
  purchaseState: IPurchaseState,
  skdIdx: number,
  hideAddons = false,
  hideBundleItems = false
) {
  if (!purchaseState.stLineItems) {
    return [];
  }

  return purchaseState.stLineItems
    .filter(
      item => (item.skdIdx === skdIdx || typeof item.skdIdx === "undefined" || item.skdIdx === null) && !!item.vnt
    )
    .filter(item => (hideAddons ? !item.isAddOn : item))
    .filter(item => (hideBundleItems ? !isCPSLineItemApartOfBundle(item) : item))
    .sort(byCreatedDatesLineItems)
    .sort(byAddonStatus);
}

// If cps is active, returns next actual delivery (skipped deliveries are excluded). If paused, returns whatever the next delivery *would* have been
export function getDeliveryForCPS(purchaseState: IPurchaseState, organization: IOrganization) {
  const billingDays = OrgUtils.getOrgBillingDays(organization);
  return (
    getNextActualDeliveryForCpsGroup(organization, [purchaseState])?.[1][0] ??
    RRuleManager.fromJson(purchaseState.schedule, OrgUtils.getBillingSchedule(organization!))
      .getFutureScheduledDeliveries(5, billingDays)
      .map(delivery => ({ ...delivery, purchaseState }))
      .find(delivery => !delivery.isSkipped)
  );
}

export const useButtonCopy = (delivery: ScheduledDeliveryGroupWithPurchSt<IPurchaseState>) => {
  const { isSellingPlanDeleted, isPurchaseStatesInitialized, isSellingPlanGroupsLoading, isPaused } =
    useBasicSubscriptionInfo(delivery as PurchaseStateAndDelivery);

  const isError = isSellingPlanDeleted && isPurchaseStatesInitialized && !isSellingPlanGroupsLoading;

  if (isError) {
    return typedLocalize("subscriptions.yourNextOrder.viewImportantNotice");
  } else if (isPaused) {
    return typedLocalize("subscriptions.yourSubscriptions.resumeSubscriptions");
  }
  return typedLocalize("subscriptions.yourSubscriptions.manageSubscriptions");
};
